import { useStore } from '@/store/useStore';
import geolocationIconMapper from '@/geolocation/icons';
import getGeolocationModalConfig from '@/geolocation/screens/geolocationModalConfig';
import { useTranslation } from 'react-i18next';

import { TFunction } from 'i18next';
import { COUNTRY } from '@/utilities/constants/account';
import { GeolocationErrorType } from '@/store/slices/geolocation/types';

const getModalContent = (
  geolocationErrorType: GeolocationErrorType | null,
  t: TFunction<'translation', undefined>,
) => {
  switch (geolocationErrorType) {
    case GeolocationErrorType.General:
      return getGeolocationModalConfig(t)['geolocationError'];
    case GeolocationErrorType.PLC:
      return getGeolocationModalConfig(t)['pluginError'];
    default:
      return getGeolocationModalConfig(t)['geolocationError'];
  }
};

const GeolocationModalContent = () => {
  const { t } = useTranslation();
  const type = useStore((s) => s.geolocationError.type);

  const modalContent = getModalContent(
    type as unknown as GeolocationErrorType,
    t,
  );

  const { body, actionButtons, header } = modalContent;

  const CountryMap =
    geolocationIconMapper[
      process.env.COUNTRY === COUNTRY.CANADA ? 'CA' : 'USA'
    ];

  return (
    <>
      <div className="modal__header" data-testid="geolocation-modal">
        {header}
      </div>

      <div className="modal__image">{CountryMap && <CountryMap />}</div>

      <div className="modal__body" data-testid="geolocation-modal-message">
        {body()}
      </div>
      <div className="modal__footer">{actionButtons?.()}</div>
    </>
  );
};

export default GeolocationModalContent;
